import ExternalAPI from '../ExternalAPI';

/** @ignore */
class API extends ExternalAPI {

    constructor() {
        super();
    }

    get type() {
        return 'default';
    }

    init(callback) {
        super.init(callback);
    }

}

export default API;